import {MerieSchema} from 'src/js/common';

export const HOSPITALIZATIONS_FEATURE_NAME = 'hospitalizations' as const;
export const DOCUMENTS_FEATURE_NAME = 'documents' as const;
export const TIMELINE_FEATURE_NAME = 'timeline' as const;
export const DIAGNOSIS_LAB_RESULT_CHART = 'labResult' as const;

export const HOSPITALIZATIONS_SEARCH_COMPONENTS = {
  filter: false,
  list: false,
};
export const ROUTE_HOSPITALIZATIONS = '/hospitalizedPatients';
export const HOSPITALIZATIONS_NAVIGATION_GROUP = 'PATIENT_GROUP';

type TimelineEventTypeEnum = MerieSchema.components['schemas']['MerieEventTypeEnum'];

export const TimelineEventTypeMap: Record<TimelineEventTypeEnum, string> = {
  /* Timeline event-type icons. Medication, laboratory and microbiology (BE: CULTIVATION_*) share the icons of the
     hospitalization-list filter tabs (PDM-2842: pillsIcon, flaskIcon, bacteriumIcon); the rest keep their own
     (riskFactorStarIcon, departmentRelatedIcon, pharmacotherapyEvaluationIcon).
   */
  HOSPITALIZATION_START: 'departmentRelatedIcon',
  HOSPITALIZATION_END: 'departmentRelatedIcon',
  TRANSFER: 'departmentRelatedIcon',
  HEPATIC_INSUFFICIENCY: 'riskFactorStarIcon',
  RENAL_INSUFFICIENCY: 'riskFactorStarIcon',
  EPILEPSY: 'riskFactorStarIcon',
  DIABETES_MELLITUS: 'riskFactorStarIcon',
  ATRIAL_FIBRILLATION_OR_FLUTTER: 'riskFactorStarIcon',
  MALIGNANT_NEOPLASM: 'riskFactorStarIcon',
  PARKINSON_DISEASE: 'riskFactorStarIcon',
  OBESITY: 'riskFactorStarIcon',
  MEDICATION: 'pillsIcon',
  CULTIVATION_URINE: 'bacteriumIcon',
  CULTIVATION_LOWER_RESP: 'bacteriumIcon',
  CULTIVATION_WOUND: 'bacteriumIcon',
  CULTIVATION_UPPER_RESP: 'bacteriumIcon',
  CULTIVATION_GASTRO: 'bacteriumIcon',
  CULTIVATION_CATH_VASCULAR: 'bacteriumIcon',
  CULTIVATION_BLOOD: 'bacteriumIcon',
  CULTIVATION_OTHER: 'bacteriumIcon',
  LAB_RENAL_FUNCTION: 'flaskIcon',
  LAB_HEPATIC_FUNCTION: 'flaskIcon',
  LAB_ELECTROLYTES: 'flaskIcon',
  LAB_INFLAMMATORY_MARKERS: 'flaskIcon',
  LAB_COMPLETE_BLOOD_COUNT: 'flaskIcon',
  LAB_URINE_TEST: 'flaskIcon',
  LAB_PANCREATIC_FUNCTION: 'flaskIcon',
  LAB_TDM: 'flaskIcon',
  LAB_DIABETES_PANEL: 'flaskIcon',
  LAB_ABB: 'flaskIcon',
  LAB_LIPID_PANEL: 'flaskIcon',
  LAB_ENDOCRINOLOGY: 'flaskIcon',
  LAB_BONE_PANEL: 'flaskIcon',
  LAB_CARDIAC_MARKERS: 'flaskIcon',
  LAB_ANEMIA_PANEL: 'flaskIcon',
  LAB_COAGULATION: 'flaskIcon',
  LAB_OTHER: 'flaskIcon',
  PHARMACOTHERAPEUTIC_EVALUATION: 'pharmacotherapyEvaluationIcon',
};

export const COMMENT_SECTION_MAX_HEIGHT_PX = 420;
